import Badge from './Badge.jsx'

export default function TrailerModal({ rec, onClose }) {
  if (!rec?.trailer) return null
  const vid = rec.trailer.split('v=')[1]

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.95)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '16px',
      animation: 'fadeUp 0.22s ease',
      backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)',
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        width: '100%', maxWidth: 860,
        background: '#0d1a10', borderRadius: 22, overflow: 'hidden',
        border: '1px solid rgba(30,180,100,0.2)',
        boxShadow: '0 48px 120px rgba(0,0,0,0.95)',
        animation: 'scaleIn 0.28s cubic-bezier(.22,.68,0,1.2)',
      }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', background: '#000' }}>
          <iframe
            src={`https://www.youtube.com/embed/${vid}?autoplay=1&rel=0&modestbranding=1`}
            allow="autoplay;encrypted-media;fullscreen"
            allowFullScreen
            style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 'none' }}
          />
        </div>
        <div style={{
          padding: '14px 18px',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          borderTop: '1px solid rgba(255,255,255,0.06)',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
            <span style={{
              fontSize: 15, fontWeight: 700, color: '#fff',
              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            }}>{rec.title}</span>
            <Badge id={rec.service} />
          </div>
          <button onClick={onClose} style={{
            background: 'rgba(255,255,255,0.07)',
            border: '1px solid rgba(255,255,255,0.12)',
            color: '#888', borderRadius: 9, padding: '8px 18px',
            fontSize: 13, cursor: 'pointer', fontFamily: 'inherit',
            flexShrink: 0, marginLeft: 10, minHeight: 44,
            WebkitTapHighlightColor: 'transparent',
          }}>Close</button>
        </div>
      </div>
    </div>
  )
}
